import config from "@/libs/config";
import { URLMFXPrivacyPolicyTreatment } from "@/libs/constants";
import { color } from "@/styles/theme";
import { css } from "@emotion/react";
import { Font, Icon } from "@moneyforward/mfx_biz_react_components";

const TermsLink = ({
  href,
  linkText = "",
  linkTextPrefix,
  variant,
  className,
}: {
  href: string;
  linkTextPrefix?: string;
  linkText: string;
  variant: "footer" | "form";
  className?: string;
}) => {
  const baseAStyle = css({
    // Ideally, display should not be set, i.e. default to inline.
    // However, <Font> is a block element - setting component="span" does not actually work,
    // so we do things the hard way.
    display: "flex",
    gap: "4px",
    ":hover": {
      textDecoration: "underline",
      opacity: 0.7,
      cursor: "pointer",
    },
  });

  const variantAStyle =
    variant === "form"
      ? {
          color: color.link,
        }
      : {};

  return (
    <div
      css={{
        display: "flex",
        gap: "4px",
        flexWrap: "wrap",
        justifyContent: "top",
      }}
    >
      {variant === "form" && linkTextPrefix && (
        <Font variant="m">{linkTextPrefix}</Font>
      )}
      <a
        href={href}
        target="_blank"
        css={[baseAStyle, variantAStyle]}
        className={className}
      >
        {linkText}

        {variant === "form" && (
          <Icon
            name="openInNew"
            size="sm"
            css={{
              marginTop: "2px",
              ":hover": {
                cursor: "pointer",
              },
            }}
          />
        )}
      </a>
      {variant === "form" && <Font variant="m">に同意する</Font>}
    </div>
  );
};

export const TermsOfUseLinkForm = () => {
  return (
    <TermsLink
      variant="form"
      href="/terms/id"
      linkText="Mikatano ID 利用規約"
    />
  );
};

export const TermsOfUseLinkFooter = () => {
  return (
    <TermsLink
      variant="footer"
      href="/terms/id"
      linkText="Mikatano ID 利用規約"
    />
  );
};

export const SpecialTermsLinkForm = () => {
  return (
    <TermsLink
      variant="form"
      href="/terms/policy_data_provision"
      linkTextPrefix={`${config.BANK_FORMAL_NAME}への`}
      linkText="利用者情報の第三者提供に関する特約"
    />
  );
};

export const SpecialTermsLinkFooter = () => {
  return (
    <TermsLink
      variant="footer"
      href="/terms/policy_data_provision"
      linkTextPrefix={`${config.BANK_FORMAL_NAME}への`}
      linkText="利用者情報の第三者提供に関する特約"
    />
  );
};

export const PrivacyPolicyLinkForm = () => {
  return (
    <TermsLink
      variant="form"
      href="https://corp.moneyforward.com/privacy/"
      linkText="個人情報保護方針"
    />
  );
};

export const PrivacyPolicyLinkFooter = () => {
  return (
    <TermsLink
      variant="footer"
      href="https://corp.moneyforward.com/privacy/"
      linkText="個人情報保護方針"
    />
  );
};

export const PrivacyPolicyTreatmentLinkForm = () => {
  return (
    <TermsLink
      variant="form"
      href={URLMFXPrivacyPolicyTreatment}
      linkText="個人情報の取扱について"
    />
  );
};
